class SwitchableVideoThumbs
{
    constructor ( container )
    {

        this.container = container;


        if ( !this.container.dataset.video || this.container.dataset.video.length < 1 )
        {
            // no video info
            return;
        }

        this.bindEvent();
    }

    bindEvent ()
    {
        this.container.addEventListener( 'click', this.switchVideo.bind( this ) );
    }

    unbindEvent ()
    {
        this.container.classList.remove( 'switchable-video-thumbnail' );
        this.container.removeEventListener( 'click', this.switchVideo );
    }

    switchVideo ()
    {

        let parent = this.container.closest( '.featured-image-container' );

        parent.classList.add( 'switched-to-video' );

        this.container.innerHTML = this.container.dataset.video
        this.unbindEvent();
    }

}


document.addEventListener( 'DOMContentLoaded', () =>
{
    const switchableVideos = document.querySelectorAll( '.switchable-video-thumbnail' );

    if ( switchableVideos.length < 1 )
    {
        return;
    }


    Array.from( switchableVideos ).forEach( el => new SwitchableVideoThumbs( el ) );

} );
